import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';

import CategoryCommand from './CategoryCommand';

class ExcelExportCommand extends CategoryCommand<void> {
  public static COMMAND_NAME = 'excelExport' as const;

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.EXCEL_EXPORT,
    };
  }

  public getIcon(): IconName {
    return 'excel';
  }

  public getName(): CommandName {
    return ExcelExportCommand.COMMAND_NAME;
  }

  public isAvailable(context: ClientContext): boolean {
    return context.has('Id');
  }
}

export default ExcelExportCommand;
